import moment from 'moment';
export const formatToUTC = date => {
  const val = moment(date);
  return val._d;
};
